import React from 'react';
import { Card, CardGroup } from 'react-bootstrap';
import useReviews from '../../hooks/useReviews';

const SingleReview = () => {
    const [reviews, setReviews] = useReviews()
    return (
        // <div className='container mt-5 mb-5 py-3 d-flex justify-content-center gap-5'>
        <CardGroup className='container'>
            {reviews.slice(1, 4).map(review =>
                <Card className='m-4 border-light rounded shadow'>
                    <Card.Img className='p-4' variant="top" src={review.img} />
                    <Card.Body>
                        <Card.Title >{review.name}</Card.Title>
                        <Card.Text>
                            {review.comment}
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                        <small className="text-muted">Ratings: {review.rating}</small>
                    </Card.Footer>
                </Card>
            )}
        </CardGroup>
        // </div>

    );
};

export default SingleReview;